import { generatePath } from 'react-router-dom';
import frontendLog from '../libs/frontendLog';
import { gameConfig } from '../../../shared/gameConfig';
import { TWowRetailRoutes } from '../../../../../shared/gameConfig/wowretail/routes';

export const namedRoutes = gameConfig.Routes as TWowRetailRoutes;

export function resolveRoutePath(path: string, params?: Object): string {
  try {
    return generatePath(path, params);
  } catch (err) {
    frontendLog.error({ err, path, params }, 'resolveRoutePath failed');
    return '/';
  }
}

//
// Helpers
//
export function getPathToRun(run: any): string {
  return resolveRoutePath(namedRoutes.MythicKeystoneRun, {
    season: run.season,
    id: `${run.keystone_run_id}-${run.mythic_level}-${run.dungeon.slug}`
  });
}

export function getPathToLoggedRun(run: any): string {
  return resolveRoutePath(namedRoutes.MythicKeystoneLoggedRun, {
    season: run.season,
    id: `${run.logged_run_id}-${run.mythic_level}-${run.dungeon.slug}`
  });
}
